
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/professor/[slug]",
      function () {
        return require("private-next-pages/professor/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/professor/[slug]"])
      });
    }
  